import { DataLogOption } from '@iotize/tap/service/impl/data-log';
import { GET, POST } from '../annotations';
import { uint16, uint8 } from '../converters';
import { TapServerError } from '../tap-server-error';
import { VirtualTap } from '../virtual-tap-server';

export class DatalogService {

    get datalogEngine() {
        return this.server.dataLogEngine;
    }

    constructor(public server: VirtualTap) {

    }

    @GET({
        path: '/1024//23',
        responseType: uint16
    })
    public getMaxPacketCount() {
        return 0xFFFF;
    }

    @GET({
        path: '/1031//0',
        responseType: uint8
    })
    public isRunning() {
        return this.datalogEngine.running;
    }

    @POST({
        path: '/1031//0'
    })
    public run() {
        this.datalogEngine.start();
    }

    @POST({
        path: '/1031//1'
    })
    public stop() {
        this.datalogEngine.stop();
    }

    @GET({
        path: '/1031//2'
    })
    public getOptions(): DataLogOption {
        return {
            autorun: false,
            logOnChange: false,
            qos: false,
            rollingMode: false,
            security: false
        }
    }

    @POST({
        path: '/1031//4'
    })
    public flush() {
        this.datalogEngine.flush();
    }

    @GET({
        path: '/1031//10',
        responseType: uint16
    })
    public getPacketCount() {
        return this.datalogEngine.packets.length;
    }

    @GET({
        path: '/1031//11'
    })
    public dequeuePacket() {
        if (this.datalogEngine.packets.length === 0) {
            throw TapServerError.notImplemented();
        }
        const packet = this.datalogEngine.dequeue();
        return packet;
    }

}